var classList = require('dom-classlist');
var pubsub = require('pubsub');
var gsap = require('gsap');
var Slider = require('partials/slider.js');
var ScrollTo = require('partials/scroll-to');

module.exports = function (el) {
	var _el = el
	,	_firstSide = _el.querySelector('.side:first-child')
	,	_lastSide = _el.querySelector('.side:last-child')

    function addHandlers(){
		/*BLOC T3*/
		var sides = _el.querySelectorAll('div.side:not(.empty)');
		Array.prototype.forEach.call(sides, function(el){
			//init only first bloc if second is empty
			if(!el.querySelector('.content')) return;
			var _side = el
			,	_content = _side.querySelector('.content')
			,	_contentHidden = _side.querySelector('.content-hidden')
			,	_btTriggerAnim = _side.querySelector('.triggerAnim')
			,	_btClose = _side.querySelector('.close')
			,	tl = new TimelineLite({
		        paused:true,
		        onReverseComplete: function(){
		            //
		            pubsub.emit('update:posAnim') //svg-animation.js
		        },
		        onComplete: function(){
		            //
		            pubsub.emit('update:posAnim') //svg-animation.js
		        }
		    })
			,	init = false;
			tl.to(_content, .3, {autoAlpha: 0 })
			tl.to(_contentHidden, .3, {autoAlpha: 1})
			/*ANIM HOVER BUTTON*/
			_btTriggerAnim.addEventListener('mouseenter', hoverHalfTrigger);
			_btTriggerAnim.addEventListener('mouseleave', function(){
				removeSidesClasses();
			});

			/*ANIM ON CLICK*/
			if(classList(_btTriggerAnim).contains('slideHalf')){
				_btTriggerAnim.addEventListener('click', function(e){
					e.preventDefault();
					removeSidesClasses();

					classList(_side).add('open');

					/*init swiper*/
					if(!init){
						setTimeout(function(){
							pubsub.emit('slider:init', _side);
						}, 500)
					}

					if(_side === _firstSide){
						classList(_lastSide).add('nopen');
					} else {
						classList(_firstSide).add('nopen');
					}
					//classList(bloc.parentNode.querySelector('div.side:not(.open)')).add('nopen');
					tl.play()

					ScrollTo(_el, 1)
					//classList(bloc.querySelector('.close')).add('visible');
				});
			}
			/*ANIM ON CLOSE*/
			if(!_btClose) return;
			_btClose.addEventListener('click', function(e){
				e.preventDefault()
				tl.reverse()
				classList(_side).remove('open');
				if(_side === _firstSide){
					classList(_lastSide).remove('nopen');
				} else {
					classList(_firstSide).remove('nopen');
				}
			})
		})
    }

	function removeSidesClasses(){
		classList(_firstSide).remove('hover');
		classList(_firstSide).remove('nohover');
		classList(_lastSide).remove('hover');
		classList(_lastSide).remove('nohover');
	}

	/*HALF HOVER ANIM*/
	function hoverHalfTrigger(e){
		e.preventDefault();
		var side = this.parentNode.parentNode.parentNode.parentNode;

		hoverHalfAnim(side);

	}

	function hoverHalfAnim(side){
		//remove old class
		removeSidesClasses();

		if(side === _firstSide){
			//anim current
			classList(_firstSide).add('hover');
			//anim other
			classList(_lastSide).add('nohover');
		}else{
			//anim current
			classList(_lastSide).add('hover');
			//anim other
			classList(_firstSide).add('nohover');
		}

	}

    addHandlers()
}
